import LandingPage, { type LandingPageData } from "./landing";
import { landingContent } from "@shared/landing-content";

const data: LandingPageData = {
  path: "/meta-ads-bureau-amsterdam",
  seo: {
    nl: {
      title: "Meta Ads Bureau voor D2C E-commerce | Wrkt Digital",
      description: "Wrkt Digital is gespecialiseerd in Meta Ads voor D2C e-commerce merken. AI-gedreven adverteren op Facebook en Instagram met bewezen creative frameworks en 24/7 optimalisatie.",
      keywords: "Meta Ads e-commerce bureau, Facebook adverteren webshop, D2C advertising bureau Nederland, Instagram ads bureau, Meta advertising agency, Facebook ads agency Amsterdam, facebook adverteren uitbesteden, facebook marketing uitbesteden, facebook ads uitbesteden, facebook marketing bureau, facebook advertising uitbesteden, facebook ads agency, facebook marketing, facebook marketing agency, instagram adverteren uitbesteden",
    },
    en: {
      title: "Meta Ads Agency for D2C E-commerce | Wrkt Digital",
      description: "Wrkt Digital specializes in Meta Ads for D2C e-commerce brands. AI-driven advertising on Facebook and Instagram with proven creative frameworks and 24/7 optimization.",
      keywords: "Meta Ads e-commerce agency, Facebook advertising webshop, D2C advertising agency Netherlands, Instagram ads agency, Meta advertising agency Amsterdam, facebook advertising outsource, facebook marketing agency, facebook ads agency, facebook marketing outsource, facebook advertising agency",
    },
  },
  content: landingContent["/meta-ads-bureau-amsterdam"],
};

export default function LandingMetaAds() {
  return <LandingPage data={data} />;
}
